import BasketIcon from "../../../assets/icons/BasketIcon";
import FavoriteIcon from "../../../assets/icons/FavoriteIcon";
import HamburgerIcon from "../../../assets/icons/HamburgerIcon";
import Logo from "../../../assets/Logo";
import UserIcon from "../../../assets/icons/UserIcon";
import SearchInput from "../../input/SearchInput";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import HamburgerMenu from "../../menu/HamburgerMenu";
import HamburgerCloseIcon from "../../../assets/icons/HamburgerCloseIcon";
// import HeaderWarehouseInfo from "../../warehouse/HeaderWarehouseInfo";
import { useCartStore } from "../../../store/cartStore";
import { useProductStore } from "../../../store/productStore";

function HeaderDesktop() {
    const navigate = useNavigate();
    const { resetFilters } = useProductStore();
    const [menuOpen, setMenuOpen] = useState(false);

    // Товары корзины
    const { items } = useCartStore();
    // Считаем количество
    const cartCount = items.reduce((total, item) => total + (item.quantity || 0), 0);

    const handleLogoClick = () => {
        navigate("/", { replace: true });
        setTimeout(() => resetFilters(), 500);
    };

    const closeMenu = () => setMenuOpen(false);

    // Переходы
    const handleProfileClick = () => navigate("/profile");
    const handleFavoritesClick = () => navigate("/favorites");
    const handleCartClick = () => navigate("/cart");

    return (
        <>
            <header className="fixed top-0 left-0 right-0 z-50 bg-white">
                <div className="container mx-auto md:px-4 hidden md:flex items-center justify-between py-4">
                    {/* Левая часть: бургер + лого */}
                    <div className="flex items-center">
                        <button onClick={() => setMenuOpen((prev) => !prev)} className="mr-5 transition-transform duration-300">
                            {!menuOpen ? (
                                <HamburgerIcon className="w-8 h-8" />
                            ) : (
                                <HamburgerCloseIcon className="w-8 h-8" />
                            )}
                        </button>
                        <button onClick={handleLogoClick}>
                            <Logo />
                        </button>
                    </div>

                    {/* Поиск */}
                    <div className="flex-1 mx-10 lg:mx-16">
                        <SearchInput placeholder="Поиск..." />
                    </div>

                    {/* Иконки: профиль, избранное, корзина */}
                    <div className="flex items-center space-x-5 mx-10 lg:mx-16">
                        {/* Профиль */}
                        <button onClick={handleProfileClick} className="flex flex-col items-center">
                            <div className="flex items-center justify-center w-6 h-6">
                                <UserIcon className="w-7 h-7" isActive={location.pathname === "/profile"} />
                            </div>
                        </button>

                        {/* Избранное */}
                        <button onClick={handleFavoritesClick} className="flex flex-col items-center">
                            <div className="flex items-center justify-center w-6 h-6">
                                <FavoriteIcon className="w-7 h-7" isActive={location.pathname === "/favorites"} />
                            </div>
                        </button>

                        {/* Корзина */}
                        <div className="relative group">
                            {/* Кнопка корзины */}
                            <button onClick={handleCartClick} className="flex flex-col items-center">
                                <div className="flex items-center justify-center w-6 h-6">
                                    <BasketIcon
                                        className="w-7 h-7"
                                        // Если пусто, показываем "пустую" иконку, иначе "полную"
                                        isEmpty={cartCount === 0}
                                        isActive={location.pathname === "/cart"} 
                                    />
                                </div>
                            </button>

                            {/* Тултип показываем только если есть товары */}
                            {cartCount > 0 && (
                                <div
                                    className="
                    absolute 
                    left-1/2 top-full 
                    transform -translate-x-1/2 
                    mt-2 
                    flex items-center justify-center
                    px-3 py-2 
                    bg-[#FF522D] text-white text-sm font-medium
                    rounded-[8px] 
                    opacity-0 group-hover:opacity-100 
                    transition-opacity duration-200
                    z-10

                    // Псевдоэлемент для «хвостика» сверху
                    before:content-[''] 
                    before:absolute 
                    before:-top-4 
                    before:left-1/2 
                    before:-translate-x-1/2
                    before:border-[10px] 
                    before:border-transparent 
                    before:border-b-[#FF522D]
                  "
                                >
                                    {cartCount}
                                </div>
                            )}
                        </div>
                    </div >

                    {/* Информация о текущем складе */}
                    {/* <HeaderWarehouseInfo /> */}
                </div >
            </header >

            {menuOpen && <div
                className={`fixed top-16 left-0 right-0 bg-white shadow-md z-40 overflow-hidden transition-max-height duration-500 ease-in-out ${menuOpen ? "max-h-[500px]" : "max-h-0"
                    }`}
            >
                <HamburgerMenu onClose={closeMenu} isMobile={false} />
            </div>
            }
        </>
    );
}

export default HeaderDesktop;
